import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Button,
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { DomainValue } from "../../services/mdmService/types";
import { mdmDataUpload } from "../../services/mdmService";
import uploadButtonIcon from "../../assets/image/svg/uploadButtonIcon.svg";
import MDMfileUpload from "../../components/dataUploadLayout/dataUploadHomeScreen/excelUpload/widgets/dataUploadSection/fileUploadMDM";
import UpdatedMDMfileUpload from "./UpdatedFileUploadMDM";

interface UploadPopupProps {
  open: boolean;
  handleClose: () => void;
  selectedMaster: DomainValue;
  loader: boolean;
  setLoader: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedMaster: React.Dispatch<
    React.SetStateAction<DomainValue | undefined>
  >;
}

const UploadPopup: React.FC<UploadPopupProps> = ({
  open,
  handleClose,
  selectedMaster,
  loader,
  setLoader,
  setSelectedMaster,
}) => {
  const [downloadUrl, setDownloadUrl] = useState<string | undefined>("");
  const [file, setFile] = useState<File | undefined>();

  const uploadOnClick = async () => {
    if (!file) {
      console.error("No file selected");
      return;
    }
    setLoader(true);
    handleClose(); // Close popup
    const formData = new FormData();
    formData.append("file", file);

    // Assuming `mdmDataUpload` is a function that handles the actual upload
    await mdmDataUpload(
      formData,
      selectedMaster.entityName ?? "",
      file,
      setLoader,
      selectedMaster.useKafka ?? false,
      selectedMaster.transformer
    );
    setFile(undefined); // Reset file after upload
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        setFile(undefined);
        handleClose();
      }}
      maxWidth="sm"
    >
      <Box
        sx={{
          padding: "10px",
          borderRadius: "8px",
          position: "relative",
          backgroundColor: "#fff",
          textAlign: "center",
          width: "650px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginLeft: "15px",
            marginRight: "55px",
          }}
        >
          <DialogTitle
            sx={{
              textAlign: "center",
              font: "normal normal 600 16px/34px Poppins",
              color: "#434343",
              padding: "0px",
            }}
          >
            {`Upload Excel for ${selectedMaster.name}`}
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={(e)=>{
              setFile(undefined)
              handleClose()
            }}
            sx={{
              color: "#000000",
              paddingRight: "13px",
            }}
          >
            <CloseIcon />
          </IconButton>
        </div>

        <DialogContent sx={{ padding: "0px" }}>
          <UpdatedMDMfileUpload
            selectedMaster={selectedMaster}
            Open={open}
            setShowModal={handleClose}
            downloadUrl={downloadUrl}
            loader={loader}
            setLoader={setLoader}
            setSelectedMaster={setSelectedMaster}
            file={file}
            setFile={setFile}
          />
        </DialogContent>
        <Box display={"flex"} flexDirection={"row-reverse"} marginBottom={"5px"} width={"90%"}>
          <Button
            variant="contained"
            disabled={!file}
            sx={{
              width: "20%",
              backgroundColor: "#00C6B1",
              color: "#fff",
              padding: "5px 12px",
              fontSize: "14px",
              "&:hover": {
                backgroundColor: "#00C6B1",
              },
              display: "flex",
              justifyContent: "space-between",
              marginTop: "10px",
            }}
            onClick={uploadOnClick}
          >
            <>
              <img src={uploadButtonIcon} alt="Upload" />
              Upload
            </>
          </Button>
          <Button
            variant="outlined"
            onClick={handleClose}
            sx={{
              width: "20%",
              color: "grey",
              padding: "5px 12px",
              fontSize: "14px",
              outline: "grey",
              display: "flex",
              justifyContent: "space-between",
              marginTop: "10px",
              marginRight: "5px",
              border:"gray 1px solid"
            }}
          >
            Cancel
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default UploadPopup;

